import { createModel } from '@rematch/core';
import { get, post } from 'utils/http';

export default createModel()({
  state: {
    taskList: [], // 任务列表
    comparedTaskList: [], // 对比评估任务列表
    imgModelReviewTaskList: [], // 对比评估任务列表
  },
  reducers: {
    setState: (state: any, payload: any) => ({ ...state, ...payload }),
  },
  effects: {
    setReduxData({ key, data }) {
      this.setState({
        [key]: data,
      });
    },
    setQueryParams(data) {
      this.setState({
        queryParams: data,
      });
    },
    // 拉取项目列表
    async getTTSReviewTask(data = {}) {
      const rst = await get('/api/review/getTTSReviewTask', data);
      if (rst?.rows?.length > 0) {
        this.setState({
          taskList: rst.rows || [],
        });
      }
      return rst || {};
    },
    // 创建项目
    async createTask(data = {}) {
      const rst = await post('/api/review/createTask', data);
      return rst;
    },
    // 删除项目
    async deleteTask(data = {}) {
      const rst = await post('/api/review/deleteTask', data);
      return rst;
    },
    // 评估结果上报
    async evalResultReport(data = {}) {
      const rst = await post('/api/review/evalResultReport', data);
      return rst;
    },
    // 根据任务ID和用户ID获取评分结果
    async getTaskByInterface(data = {}) {
      const rst = await get('/api/review/getTaskByInterface', data);
      return rst;
    },
    // 生成盲评结果汇总
    async genReviewSummary(data = {}) {
      const rst = await post('/api/review/genReviewSummary', data);
      return rst;
    },
    // 生成单个盲评结果汇总
    async genSingleEvalSummary(data = {}) {
      const rst = await post('/api/review/genSingleEvalSummary', data);
      return rst;
    },
    // 横评结果存储磁盘
    async formatEvalResultToDisk(data = {}) {
      const rst = await post('/api/review/formatEvalResultToDisk', data);
      return rst;
    },
    // 获取父任务磁盘写入任务历史列表
    async getReviewResultDownloadHistory(data = {}) {
      const rst = await get('/api/review/getReviewResultDownloadHistory', data);
      return rst;
    },
    // 修改任务
    async modifyTask(data = {}) {
      const rst = await post('/api/review/modifyTask', data);
      return rst;
    },
    // 获取TTS对比评估任务列表
    async getComparedTTSReviewTask(data = {}) {
      const rst = await get('/api/review/getComparedTTSReviewTask', data);
      if (rst?.rows?.length > 0) {
        this.setState({
          comparedTaskList: rst.rows || [],
        });
      }
      return rst || {};
    },
    // 新建对比评估任务
    async createComparedTask(data = {}) {
      const rst = await post('/api/review/createComparedTask', data);
      return rst;
    },
    // 删除对比评估任务
    async deleteComparedTask(data = {}) {
      const rst = await post('/api/review/deleteComparedTask', data);
      return rst;
    },
    // 修改对比评估任务
    async modifyComparedTask(data = {}) {
      const rst = await post('/api/review/modifyComparedTask', data);
      return rst;
    },
    // 对比评估结果上报
    async evalComparedResultReport(data = {}) {
      const rst = await post('/api/review/evalComparedResultReport', data);
      return rst;
    },
    // 根据对比评估任务ID和用户ID获取评分结果
    async getComparedTaskByInterface(data = {}) {
      const rst = await get('/api/review/getComparedTaskByInterface', data);
      return rst;
    },
    // 生成对比评估结果汇总
    async genComparedReviewSummary(data = {}) {
      const rst = await post('/api/review/genComparedReviewSummary', data);
      return rst;
    },
    // 获取图片对比评估任务列表
    async getEvalTaskByInterface(data = {}) {
      const rst = await get('/api/review/getEvalTaskByInterface', data);
      if (rst?.rows?.length > 0) {
        this.setState({
          imgModelReviewTaskList: rst.rows || [],
        });
      }
      return rst || {};
    },
    // 删除图片对比评估任务
    async deleteEvalTask(data = {}) {
      const rst = await post('/api/review/deleteEvalTask', data);
      return rst;
    },
    // 修改图片模型横评任务
    async modifyEvalTask(data = {}) {
      const rst = await post('/api/review/modifyEvalTask', data);
      return rst;
    },
    // 根据父任务id获取子任务列表
    async getEvalTaskByParentTaskId(data = {}) {
      const rst = await get('/api/review/getEvalTaskByParentTaskId', data);
      return rst;
    },
    // 获取评估列表及信息
    async getEvalInfo(data = {}) {
      const rst = await post('/api/review/getEvalInfo', data);
      return rst;
    },
    // 评估结果上报
    async evalEvalResultReport(data = {}) {
      const rst = await post('/api/review/evalEvalResultReport', data);
      return rst;
    },
    // 生成评估结果汇总
    async genEvalSummary(data = {}) {
      const rst = await post('/api/review/genEvalSummary', data);
      return rst;
    },
    // 获取图片质检列表
    async getImgInspectList(data = {}) {
      const rst = await get('/api/review/getImgInspectList', data);
      return rst;
    },
    async reportInspectResult(data = {}) {
      const rst = await post('/api/review/reportInspectResult', data);
      return rst;
    },
  },
});
